export default __webpack_public_path__ + "media/images/icons_fc/camera-6fa9e3f707c692da983f2db612002c36.png";